import { Link } from "react-router-dom";
import { AlertTriangle, ArrowRight } from "lucide-react";

export const WATT_WARNING = "Wattwandern ohne zertifizierten Wattführer ist lebensgefährlich – wir raten dringend davon ab. Das Wattenmeer ist Nationalpark: Große Teile (Ruhezone) dürfen nur auf ausgewiesenen Wegen oder mit fachkundiger Führung betreten werden.";

export const mentionsWatt = (...texts) => texts.some((t) => /watt/i.test(t || ""));

export const WattWarning = ({ compact = false, showLink = true, className = "", testid = "watt-warning" }) => (
  <div role="alert" data-testid={testid}
    className={`flex gap-4 border-2 border-[#B3261E] bg-[#FBEAE8] text-[#5C1410] ${compact ? "p-4" : "p-5 md:p-6"} ${className}`}>
    <span className={`flex shrink-0 items-center justify-center bg-[#B3261E] text-white ${compact ? "h-9 w-9" : "h-11 w-11"}`}><AlertTriangle size={compact ? 18 : 22} strokeWidth={2} /></span>
    <div className="min-w-0">
      <p className={`font-sub font-semibold uppercase tracking-wider text-[#B3261E] ${compact ? "text-xs" : "text-sm"}`}>Lebensgefahr – nur mit Wattführer ins Watt</p>
      <p className={`mt-1 leading-relaxed ${compact ? "text-xs" : "text-sm"}`}>{WATT_WARNING}</p>
      {!compact && showLink && (
        <Link to="/wattfuehrer" data-testid={`${testid}-link`} className="mt-2 inline-flex items-center gap-1.5 font-sub text-sm font-semibold text-[#B3261E] underline underline-offset-4 hover:text-[#5C1410]">
          Geführte Wattwanderungen finden <ArrowRight size={14} />
        </Link>
      )}
    </div>
  </div>
);
